import React, { useEffect, useState } from 'react'
import SertificateCard from '../../components/cards/SertificateCard'
import PageTitle from '../../components/common/PageTitle'
import ThankYouLetterCard from '../../components/cards/ThankYouLetterCard'
import CloseIcon from '../../assets/icons/CloseIcon'
import SectionHeader from '../../components/common/SectionHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getCertificates, getThankyouletter } from '../../services/actions/MainAction'

function Awards() {
    const [modalVisible, setModalVisible] = useState("");
    const contentData = useSelector(state => state.Data.contentData);
    const certificates = useSelector(state => state.Data.certificates);
    const thankyouletter = useSelector(state => state.Data.thankyouletter);
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(getCertificates("certificate"));
        dispatch(getThankyouletter("thankyouletter"));
        window.scrollTo(0,0)
    },[])
  return (
    <main className=' min-h-[100vh] mb-[50px]'>
        <div className='container  '>
            {
                thankyouletter?.length !==0?
                <section  className='mt-[50px]'>
                    <SectionHeader title={contentData?.thak_you_letter} />
                
                    <div  className='grid grid-cols-4 gap-[30px] mt-[30px] max-[1200px]:grid-cols-3 gap-y-[20px] max-[800px]:grid-cols-2 max-[500px]:grid-cols-1'>
                        {
                            thankyouletter?.map((data, i)=>{
                                return(
                                    <SertificateCard url={data?.image_full_url} onOpen={()=>setModalVisible(data?.image_full_url)} />
                                )
                            })
                        }
                    </div>
                </section>:null
            }
           
            <section  className={thankyouletter?.length !==0?'mt-[10px]':"mt-[50px]"}>
                <SectionHeader title={contentData?.cover_letter} />
                <div  className='grid grid-cols-4 gap-[30px] mt-[30px] max-[1200px]:grid-cols-3 gap-y-[20px] max-[800px]:grid-cols-2 max-[500px]:grid-cols-1'>
                    {
                        certificates?.map((data, i)=>{
                            return(
                                <SertificateCard url={data?.image_full_url} onOpen={()=>setModalVisible(data?.image_full_url)} />
                            )
                        })
                    }
                    
                </div>
            </section>
           
        </div>
        {
            modalVisible !==""?
            <div className="bg-black/70 fixed top-0 left-0 w-full h-screen flex items-center justify-center z-[1000] ">
                <button  onClick={()=>setModalVisible("")} className="absolute right-[30px] top-[30px]">
                    <CloseIcon />
                </button>
                <div className="max-w-[700px] h-auto max-h-[80vh] bg-[red] max-[700px]:mx-[10px]">
                    <img className="max-w-full max-h-[80vh]" src={modalVisible} />
                </div>
            </div>:null
        }
       
    </main>
  )
}

export default Awards
